<div class="oc-page">

  <!-- ── LOADING ──────────────────────────────────────────────── -->
  <div class="oc-loading" *ngIf="!ready">
    <mat-icon class="oc-loading__icon">shopping_cart</mat-icon>
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    <p class="oc-loading__text">Cargando…</p>
  </div>

  <ng-container *ngIf="ready">

    <!-- ── HEADER ─────────────────────────────────────────────── -->
    <div class="oc-header">
      <div class="oc-header__icon"><mat-icon>shopping_cart</mat-icon></div>
      <div>
        <h1 class="oc-header__title">
          {{ view ? 'Ver pedido' : (edit ? 'Editar pedido' : 'Nuevo pedido') }}
        </h1>
        <p class="oc-header__sub">
          {{ view ? 'Detalle del pedido de compra' : (edit ? 'Modifica las líneas del pedido' : 'Crea un nuevo pedido de compra') }}
        </p>
      </div>
      <button mat-stroked-button class="oc-btn-back" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
      <button *ngIf="!edit" mat-flat-button class="oc-btn-save" (click)="save()">
        <mat-icon>save</mat-icon> Guardar pedido
      </button>
      <button *ngIf="edit && !view" mat-flat-button class="oc-btn-save" (click)="update()">
        <mat-icon>save</mat-icon> Actualizar pedido
      </button>
    </div>

    <!-- ── BODY ───────────────────────────────────────────────── -->
    <div class="oc-body">

      <!-- SECCIÓN: Proveedor -->
      <div class="oc-section">
        <div class="oc-section__head">
          <mat-icon>business</mat-icon>
          <span>Proveedor</span>
        </div>
        <div class="oc-section__body">
          <p class="oc-provider-name" *ngIf="edit">{{ selectedProviderName }}</p>
          <app-autocomplete-select *ngIf="!edit"
            [items]="contactList"
            placeholder="Selecciona un proveedor"
            [idField]="'uid'"
            [displayField]="'companyName'"
            [selectedId]="order ? order.supplierUid : null"
            (selectionChanged)="onSelectContact($event)"
            class="w-100">
          </app-autocomplete-select>
        </div>
      </div>

      <!-- SECCIÓN: Líneas del pedido -->
      <div class="oc-section" *ngIf="conceptRows.length > 0">
        <div class="oc-section__head">
          <mat-icon>list</mat-icon>
          <span>Líneas del pedido</span>
          <span class="oc-section__badge">{{ conceptRows.length }}</span>
        </div>
        <div class="oc-section__body oc-section__body--table">
          <div class="oc-table-wrap">
            <table mat-table [dataSource]="conceptRows" class="oc-table">

              <ng-container matColumnDef="productName">
                <th mat-header-cell *matHeaderCellDef>Concepto</th>
                <td mat-cell *matCellDef="let element">{{ element.productName }}</td>
              </ng-container>

              <ng-container matColumnDef="quantityOrdered">
                <th mat-header-cell *matHeaderCellDef>Unidades</th>
                <td mat-cell *matCellDef="let element">
                  <input class="oc-qty-input" type="number"
                    [value]="element.quantityOrdered" min="0"
                    (input)="updateQuantity(element, $event.target.value)"
                    [disabled]="view" />
                </td>
              </ng-container>

              <ng-container matColumnDef="unitPrice">
                <th mat-header-cell *matHeaderCellDef>Precio unit.</th>
                <td mat-cell *matCellDef="let element">{{ element.unitPrice }}</td>
              </ng-container>

              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef class="oc-col-right">Total</th>
                <td mat-cell *matCellDef="let element" class="oc-col-right oc-col-total">
                  {{ element.price | number:'1.2-2' }} €
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['productName','quantityOrdered','unitPrice','price']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['productName','quantityOrdered','unitPrice','price'];"></tr>

            </table>
          </div>
        </div>
      </div>

      <!-- Sin conceptos aún -->
      <div class="oc-empty" *ngIf="conceptRows.length === 0 && !edit">
        <mat-icon>shopping_basket</mat-icon>
        <p>Selecciona un proveedor para ver sus conceptos</p>
      </div>

    </div>

  </ng-container>

</div>
